import React, { useState } from "react";

import PropTypes from "prop-types";
import Rds from "./Rds";
import RemoteClients from "./RemoteClients";
import Vpn from "./Vpn";
import PageEntete, { useUrlTab } from "../utils/PageEntete";

const VUES = [
  { key: "vpn", label: "VPN" },
  { key: "rds", label: "RDS" },
  { key: "clients", label: "Clients" },
];

function Remote({ resourceAccess, username, token }) {
  const [search, setSearch] = useState("");

  const [vue, setVue] = useUrlTab(VUES.map((v) => v.key));

  return (
    <div className="cti-page">
      <PageEntete title="Remote" label="Vue" items={VUES} value={vue} onChange={setVue} />
      <div className="cti-panel">
        {vue === "vpn" && (
          <Vpn
            resourceAccess={resourceAccess}
            username={username}
            search={search}
            onSearchChange={setSearch}
          />
        )}
        {vue === "rds" && (
          <Rds
            token={token}
            resourceAccess={resourceAccess}
            username={username}
            search={search}
            onSearchChange={setSearch}
          />
        )}
        {vue === "clients" && (
          <RemoteClients token={token} search={search} onSearchChange={setSearch} />
        )}
      </div>
    </div>
  );
}

Remote.propTypes = {
  resourceAccess: PropTypes.object,
  username: PropTypes.string,
  token: PropTypes.string,
};

export default Remote;
